import GuideAlertsTopStats from './top-stats/guide-alerts-top-stats.vue.js';
import GuideAlertsTable from './table/guide-alerts-table.vue.js';
import GuideAlertSettingsModal from './table/guide-alert-settings-modal.vue.js';
import GuideAlertsDrawer from './drawer/guide-alerts-drawer.vue.js';

var script = {
  name: 'GuideAlertsPage',
  components: {
    GuideAlertsTopStats,
    GuideAlertsTable,
    GuideAlertSettingsModal,
    GuideAlertsDrawer
  },
  props: {
    errorData: {
      type: Array,
      required: true
    },
    segmentsMap: {
      type: Object,
      required: true
    },
    guideAlertsAggStatus: {
      type: String,
      required: true
    },
    hasAdminAccess: {
      type: Boolean,
      default: false
    },
    topStatsConfig: {
      type: Object,
      default: () => {}
    },
    tableConfig: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Array,
      default: () => []
    },
    productType: {
      type: String,
      default: 'engage'
    },
    isSavingGuideSeenTimeout: {
      type: Boolean,
      default: false
    },
    guideSeenTimeout: {
      type: Number,
      default: 10000
    },
    activeUser: {
      type: Object,
      required: true
    },
    noteAction: {
      type: Object,
      default: () => {}
    },
    noteError: {
      type: Object,
      default: () => {}
    },
    guideVisitorAggStatus: {
      type: String,
      required: true
    },
    csvAggState: {
      type: Object,
      default: () => ({})
    },
    impactedUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      guideAlertSettingsVisible: false,
      guideAlertsDrawerVisible: false,
      topStats: [],
      alert: {},
      isTypeNote: false
    };
  },
  created() {
    this.topStats = this.errorData;
  },
  methods: {
    updateTableRow(alert, closeModal) {
      this.$refs.guideAlertsTable.updateTableRow(alert, closeModal);
    },
    informError(closeModal) {
      this.$refs.guideAlertsTable.informError(closeModal);
    },
    stepLinkClick(guideId) {
      this.$emit('step-link-click', guideId);
    },
    visitorLinkClick(visitorId) {
      this.$emit('visitor-link-click', visitorId);
    },
    downloadCsv() {
      this.$emit('download-csv');
    },
    createDisplayAlert(_ref) {
      let {
        alert,
        activeAlert,
        isVisible
      } = _ref;
      this.$emit('create-display-alert', {
        alert,
        activeAlert,
        isVisible
      });
    },
    updateDisplayAlert(_ref2) {
      let {
        alert,
        activeAlert,
        isVisible
      } = _ref2;
      this.$emit('update-display-alert', {
        alert,
        activeAlert,
        isVisible
      });
    },
    updateUserSettings(settings) {
      this.$emit('update-user-settings', settings);
    },
    tableDataChange(_ref3) {
      let {
        data
      } = _ref3;
      this.topStats = data;
      this.$emit('table-data-change', {
        data
      });
    },
    showPanelUsers(_ref4) {
      let {
        guideId,
        guideStepId,
        guideShownReason
      } = _ref4;
      this.isTypeNote = false;
      this.$emit('fetch-impacted-users', {
        guideId,
        guideStepId,
        guideShownReason
      });
      this.showDrawer();
    },
    showPanelNotes(alert) {
      this.isTypeNote = true;
      this.alert = alert;
      this.showDrawer();
    },
    updateGuideSeenTimeout(timeout) {
      this.$emit('update-guide-seen-timeout', timeout);
    },
    showAlertSettings() {
      this.guideAlertSettingsVisible = true;
    },
    closeAlertSettings() {
      this.guideAlertSettingsVisible = false;
    },
    showDrawer() {
      this.guideAlertsDrawerVisible = true;
    },
    closeDrawer() {
      this.guideAlertsDrawerVisible = false;
      this.alert = {};
    },
    createNote(_ref5) {
      let {
        alert,
        text
      } = _ref5;
      this.$emit('create-note', {
        alert,
        text
      });
    },
    removeNote(_ref6) {
      let {
        alert,
        noteId
      } = _ref6;
      this.$emit('remove-note', {
        alert,
        noteId
      });
    },
    updateNote(_ref7) {
      let {
        alert,
        text,
        noteId
      } = _ref7;
      this.$emit('update-note', {
        alert,
        text,
        noteId
      });
    },
    fetchNotes(_ref8) {
      let {
        alert
      } = _ref8;
      this.$emit('fetch-notes', {
        alert
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-alerts-page.vue2.js.map
